export enum ConfirmationType {
	Delete,
	Confirm
}
